package one.devsbox.shared.devices

import one.devsbox.commons.EType

enum class ApplicationType(
    override val mask: Int,
    val installer: Boolean,
    var wwwApp: Boolean
) : EType {

    ANDROID_RUNTIME(4, true, false),
    WWW_CAMPAIGN(8, false, true),
    LINUX_RUNTIME_X64(16, true, false),
    LINUX_RUNTIME_ARM(32, true, false),
    LINUX_INIT_X64(64, false, false),
    WWW_WHEEL(128, false, true);

    companion object : EType.Finder<ApplicationType>(entries)
}

val ApplicationType.Companion.RUNTIME_INSTALLERS get() = ApplicationType.entries.filter { it.installer }

val ApplicationType.Companion.WWW_APPS get() = ApplicationType.entries.filter { it.wwwApp }